// The closed hand from the moment something draggable is pressed, not only once it starts to move - a column grip,
// a ticket board card. It holds over the whole page until the button is let go, moved or not, so a press with no
// drag (a click) closes and opens the hand without moving anything. The cursor itself is .tikit-grabbing in main.css.
export const holdGrabbingCursor = () => {
  const root = document.documentElement;
  root.classList.add('tikit-grabbing');
  const release = () => {
    root.classList.remove('tikit-grabbing');
    window.removeEventListener('pointerup', release, true);
    window.removeEventListener('pointercancel', release, true);
  };
  window.addEventListener('pointerup', release, true);
  window.addEventListener('pointercancel', release, true);
};
